// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_Cu5JY","fhlx":"index_fhlx_pe7KY clearfix","mr24":"index_mr24_JMQv4 fl","img":"index_img_rRVxx","lx_word":"index_lx_word_4kQSw fl"};